export default __webpack_public_path__ + "static/media/property_438.59b8fb58.png";